import styled from '@emotion/styled';

export const SadaEmployees = styled.div``;
